document.addEventListener('DOMContentLoaded', function () {
    function togglePharmacyPopupMobile() {
        const pharmacyNavItemMobile = document.getElementById('ListMobileMenuItem-Pharmacy');
        const pharmacyPopupMobile = document.getElementById('pharmacy-popup-mobile');
        const pharmacyPopupContentMobile = document.querySelector('.pharmacy-popup-mobile__content');
        const biosecurityNavItemMobile = document.getElementById('HeaderMobileMenuButton-biosecurity');
        const pharmacyOverlayMobile = document.querySelector('.pharmacy-popup-mobile__overlay');
        const pharmacyStayButtonMobile = document.querySelector('.pharmacy-popup-mobile__text-stay');
        const pharmacyCloseButtonMobile = document.querySelector('.pharmacy-popup-mobile__close');

        const closeTriggersMobile = [pharmacyOverlayMobile, pharmacyStayButtonMobile, pharmacyCloseButtonMobile];

        pharmacyNavItemMobile.addEventListener('click', () => {
            pharmacyPopupMobile.classList.add('active');
            setTimeout(() => {
                trapFocus(pharmacyPopupContentMobile);
            }, 0);

        });
      
        closeTriggersMobile.forEach(trigger => {
            trigger.addEventListener('click', () => {
                closePopup();
            });

            trigger.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    closePopup();
                }
            });
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                closePopup();
            }
        });

        function closePopup() {
            pharmacyPopupMobile.classList.remove('active');
            event.preventDefault();
            biosecurityNavItemMobile.focus();
        }
    }
    togglePharmacyPopupMobile();
});